import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { globalFormManagementServices } from "../../../../../APIServices/globalFormManagementServices";

const AddFormFieldLibraryForm = ({ Show, Hide, Title, getGlobalFormFieldGroupLibrary }) => {
  const [categoryName, setCategoryName] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const addNewGlobalFormFieldLibrary = async () => {
    setButtonLoader(true);
    let userData = {}
    userData.categoryName = categoryName
    let data = await globalFormManagementServices.addNewGlobalFormFieldLibrary(userData)
    if (data?.statusCode === 200) {
      setCategoryName("")
      getGlobalFormFieldGroupLibrary()
      Hide()
    }
    setButtonLoader(false);
  }

  useEffect(() => {
    setCategoryName("");
  }, []);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Library Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCategoryName(e.target.value)}
              value={categoryName}
              className="br3"
              placeholder="Library Name"
              type="text"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top hstack justify-content-end gap-2">
          <button
            disabled={!categoryName || buttonLoader}
            className="updateProfile"
            onClick={(e) => addNewGlobalFormFieldLibrary(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Adding...
              </div>
            ) : (
              "Add form field library"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default AddFormFieldLibraryForm;
